import { useContext, useCallback } from "react";
import { LoaderContext } from "../contexts";

export function useFetch() {
    const { toggle } = useContext(LoaderContext);
    const fetcher = useCallback(
        async function fetcher(callBack: Promise<any>) {
            toggle();
            return await callBack.finally(() => toggle());
        },
        [toggle]
    );
    return { fetcher };
}
